import areaStroe from './areaStore';

export default {
  install(store) {
    if (!store.state.base) {
      store.registerModule(['base'], {
        state: {},
      });
    }
    if (!store.state.base.area) {
      store.registerModule(['base', 'area'], areaStroe);
    }
  },
  uninstall(store) {
    store.unregisterModule(['base', 'area']);
  },
};
